export default class ProductHelper {
    static filterRealSubTradeProducts(tradeProducts) {
        let uniqueRealSub = []
        let uniqueTradeProducts = []
    
        if(tradeProducts != null) {
            tradeProducts.forEach((tradeProduct) => {
                if(!!tradeProduct.realSub && !uniqueRealSub.includes(tradeProduct.realSub)) {
                    uniqueRealSub.push(tradeProduct.realSub)
                    uniqueTradeProducts.push(tradeProduct)
                }
                else if (!tradeProduct.realSub || /^\s*$/.test(tradeProduct.realSub)) {
                    uniqueTradeProducts.push(tradeProduct)
                }
            })
        }
        return uniqueTradeProducts
    }
}